import { useInstancesByQuery } from 'hive-react-utils';
export function useResponseCareTipsByResponseIds(responseIds) {
    return useInstancesByQuery('ecarepd', 'responseCareTipsByResponseIDs', 'responseCareTip', {}, responseIds);
}
